import React, { useEffect } from 'react'
import TotalCovidCard from '../components/TotalCovidCard'
import fetchDataTotal from '../store/middlewares/fetchDataTotal'
import Loader from 'react-loader-spinner'
import { useSelector, useDispatch } from 'react-redux'


const HomePage = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchDataTotal())
  }, [])
  
  const { dataTotal, dataTotalLoading } = useSelector(state => state)

  if (dataTotalLoading) {
    return <Loader
    type="ThreeDots"
    color="#00BFFF"
    height={500}
    width={500}
    className="text-center"
    />
  } else {
    return (
      <div className="container mt-5 text-center">
        <h1>Jumlah Kasus di Indonesia</h1>
        <TotalCovidCard dataTotal={dataTotal} />
      </div>
    )
  }
}

export default HomePage